var $01de2837b3b6f15a$exports = {};
$01de2837b3b6f15a$exports = {
    "loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}\u{2026}`
};


export {$01de2837b3b6f15a$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
